module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/video-hot-c5d74b0bd3423d1338d820ae1ea325c4.svg";